import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/lib/auth";
import { SiteSettingsProvider } from "@/lib/SiteSettingsContext";
import { CookieConsentProvider } from "@/lib/cookieConsent";
import CookieBanner from "@/components/public/CookieBanner";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import PublicLayout from "@/components/public/PublicLayout";
import HomeLayout from "@/components/home/HomeLayout";

// Public pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

// Admin pages
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import ServicesPage from "@/pages/admin/Services";
import CaseStudiesPage from "@/pages/admin/CaseStudies";
import BlogPage from "@/pages/admin/Blog";
import PricingPage from "@/pages/admin/Pricing";
import TestimonialsPage from "@/pages/admin/Testimonials";
import FaqsPage from "@/pages/admin/Faqs";
import EnquiriesPage from "@/pages/admin/Enquiries";
import SettingsPage from "@/pages/admin/Settings";

function App() {
    return (
        <HelmetProvider>
            <MotionConfig reducedMotion="user">
            <SiteSettingsProvider>
                <CookieConsentProvider>
                <AuthProvider>
                    <BrowserRouter>
                    <Routes>
                        {/* Dark-themed homepage */}
                        <Route element={<HomeLayout />}>
                            <Route path="/" element={<Home />} />
                        </Route>
                        {/* White/navy inner pages */}
                        <Route element={<PublicLayout />}>
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/services/:slug" element={<ServiceDetail />} />
                            <Route path="/case-studies" element={<CaseStudies />} />
                            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogDetail />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/contact" element={<Contact />} />
                        </Route>

                        {/* Admin */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route
                            path="/admin"
                            element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}
                        >
                            <Route index element={<Navigate to="dashboard" replace />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="services" element={<ServicesPage />} />
                            <Route path="case-studies" element={<CaseStudiesPage />} />
                            <Route path="blog" element={<BlogPage />} />
                            <Route path="pricing" element={<PricingPage />} />
                            <Route path="testimonials" element={<TestimonialsPage />} />
                            <Route path="faqs" element={<FaqsPage />} />
                            <Route path="enquiries" element={<EnquiriesPage />} />
                            <Route path="settings" element={<SettingsPage />} />
                        </Route>

                        <Route path="*" element={<NotFound />} />
                    </Routes>
                    <Toaster position="top-right" richColors />
                    <CookieBanner />
                </BrowserRouter>
            </AuthProvider>
            </CookieConsentProvider>
        </SiteSettingsProvider>
        </MotionConfig>
        </HelmetProvider>
    );
}

export default App;
